import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "op-screen mx-auto flex max-w-3xl flex-col gap-10 px-6 pt-4 pb-12" };
import { Alert } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TaxReceiptLinkStatusView',
    props: {
        variant: {}
    },
    setup(__props) {
        // Intentionally stateless. Shown after nginx turns an OPDON 410 (expired) / 404 (invalid, revoked,
        // unknown) into a redirect; never echoes the token. Structure mirrors the generic ErrorView.
        // Literal maps, not a template string, so a grep for the key finds its use site.
        const TITLE_KEYS = {
            expired: "documents.taxReceiptLink.expired.title",
            unavailable: "documents.taxReceiptLink.unavailable.title",
        };
        const DESCRIPTION_KEYS = {
            expired: "documents.taxReceiptLink.expired.description",
            unavailable: "documents.taxReceiptLink.unavailable.description",
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("main", _hoisted_1, [
                _createVNode(_unref(Alert), {
                    color: "danger",
                    heading: _ctx.$t(TITLE_KEYS[__props.variant]),
                    message: _ctx.$t(DESCRIPTION_KEYS[__props.variant])
                }, null, 8 /* PROPS */, ["heading", "message"])
            ]));
        };
    }
});
